export default "__VITE_ASSET__7efda6e5__"